/* eslint-disable jsx-a11y/label-has-for */
// this rule is deprecated so I'm ignoring it.
// https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/label-has-for.md

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';

const InventorySort = ({ sortOptions /* displayStyle */ }) => {
	const { widgetName, windowId } = useRequestData();
	const labels = useLabels();
	const [sortAnnouncement, setSortAnnouncement] = useState('');

	const handleChange = (e) => {
		const { value } = e.target;
		const selectedOption = sortOptions.find((o) => o.value === value);

		trackEvent(widgetName, windowId, {
			element: 'Sort select',
			elementCTA: value,
			fieldValue: value,
			result: 'Results updated with sort selection'
		});

		window.DDC.InvData.setSortBy(value || '');

		window.DDC.pushToGtmDataLayer({
			event: 'ddc.form.change',
			eventData: {
				element: e.target,
				event: 'ddc.form.change',
				formEventId: '',
				label: selectedOption.label,
				linkType: 'select-one',
				widgetName: 'ws-inv-listing'
			}
		});

		// Announce sort change to screen readers
		// Note: This state update also triggers an immediate re-render, which
		// causes the select to reflect the new sort value instantly (without it,
		// the select only updates on the next external re-render).
		setSortAnnouncement(
			value
				? labels
						.get('SORTED_BY_X')
						.replace('{sort option}', selectedOption.label)
				: labels.get('SORT_ORDER_CLEARED')
		);
	};

	// TODO: Uncomment this once the utility class for sort dropdown is finalized

	// const sortClasses = `form-control ${
	// 	displayStyle === 'transparent' ? 'form-control-transparent' : ''
	// }`.trim();

	const selectedValue = window.DDC.InvData.getSortBy();
	const currentValue = Array.isArray(selectedValue)
		? selectedValue[0]
		: selectedValue;

	return sortOptions && sortOptions.length ? (
		<React.Fragment>
			<label htmlFor="sortBy" className="sr-only">
				{labels.get('SORT_BY')}
			</label>
			<select
				id="sortBy"
				className="form-control font-size-ios-zoom-override"
				value={currentValue}
				onChange={handleChange}
			>
				{sortOptions.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
			<span className="sr-only" role="status" aria-live="polite">
				{sortAnnouncement}
			</span>
		</React.Fragment>
	) : null;
};

InventorySort.propTypes = {
	sortOptions: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.string
		})
	)
	// displayStyle: PropTypes.string
};

InventorySort.defaultProps = {
	sortOptions: []
	// displayStyle: ''
};

export default InventorySort;
